import { useParam } from './useParam';

/**
 * Type-safe function for reading the `:flagKey` URL parameter.
 * Will throw error if `:flagKey` is not present in the URL.
 */
export function useFlagKey() {
  return useParam('flagKey');
}
